'use client';

import { c as _c } from "react/compiler-runtime";
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { IoMdHeart, IoMdHeartEmpty } from 'react-icons/io';
import { myCruzApi } from '@/api';
import { Button, CruzIcon } from '@/components';
import { useGlobalStore } from '@/store/provider';
type Props = {
  _id: string;
  buttonStyle?: string;
};
const btnStyle = 'text-sm font-medium dark:font-light';
export const ToggleSaveVehicle = t0 => {
  const $ = _c(21);
  const {
    _id,
    buttonStyle
  } = t0;
  const {
    user,
    setModalSignIn,
    setUser
  } = useGlobalStore(_temp);
  const [isSaving, setIsSaving] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  let t1;
  if ($[0] !== _id || $[1] !== user?.saved_vehicle_ids) {
    t1 = () => {
      setIsSaved(!!user?.saved_vehicle_ids?.includes(_id));
    };
    $[0] = _id;
    $[1] = user?.saved_vehicle_ids;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = user?.saved_vehicle_ids;
  let t3;
  if ($[3] !== _id || $[4] !== t2) {
    t3 = [t2, _id];
    $[3] = _id;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t1, t3);
  let t4;
  if ($[6] !== _id || $[7] !== setModalSignIn || $[8] !== setUser || $[9] !== user) {
    t4 = async function handleSaveVehicle() {
      if (_.isEmpty(user)) {
        setModalSignIn({
          show: true,
          saveVehicleId: _id
        });
        return;
      }
      try {
        setIsSaving(true);
        const {
          data
        } = await myCruzApi.saveVehicle.toggleSave(_id);
        setUser(_.assign(user, data), null);
        setIsSaving(false);
      } catch {
        setIsSaving(false);
      }
    };
    $[6] = _id;
    $[7] = setModalSignIn;
    $[8] = setUser;
    $[9] = user;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const handleSaveVehicle = t4;
  const t5 = isSaved ? "Remove from saved vehicles" : "Save vehicle";
  let t6;
  if ($[11] !== isSaved || $[12] !== isSaving) {
    t6 = isSaved ? <><IoMdHeart className="size-4 text-red-700" aria-hidden="true" /><span className={btnStyle}>Saved</span></> : <>{isSaving && <CruzIcon.Spin aria-hidden="true" />}<IoMdHeartEmpty className="size-4" aria-hidden="true" /><span className={btnStyle}>Save</span></>;
    $[11] = isSaved;
    $[12] = isSaving;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== buttonStyle || $[15] !== handleSaveVehicle || $[16] !== isSaved || $[17] !== isSaving || $[18] !== t5 || $[19] !== t6) {
    t7 = <Button type="button" variant="outline" className={buttonStyle} onClick={handleSaveVehicle} aria-pressed={isSaved} aria-label={t5} disabled={isSaving}>{t6}</Button>;
    $[14] = buttonStyle;
    $[15] = handleSaveVehicle;
    $[16] = isSaved;
    $[17] = isSaving;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};
function _temp(state) {
  return state;
}